import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CareerApplicationRequest, CareerApplicationResponse, CareerApplicationsPage } from '../models/careers.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CareersService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/Careers`;

  uploadFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('File', file);
    return this.http.post(`${this.apiUrl}/UploadFile`, formData, { responseType: 'text' })
      .pipe(
        map(url => url.trim().replace(/^`|`$/g, '')) // Remove any backticks or whitespace
      ) as Observable<string>;
  }

  submitApplication(data: CareerApplicationRequest): Observable<CareerApplicationResponse> {
    // Backend expects multipart/form-data — build FormData manually
    const formData = new FormData();
    formData.append('FirstName', data.FirstName);
    formData.append('LastName', data.LastName);
    formData.append('Email', data.Email);
    formData.append('Phone', data.Phone);
    formData.append('Position', data.Position);
    formData.append('Experience', data.Experience);
    formData.append('ResumeUrl', data.ResumeUrl);
    if (data.LinkedIn != null) formData.append('LinkedIn', data.LinkedIn);
    if (data.WhyTriStar != null) formData.append('WhyTristar', data.WhyTriStar);
    if (data.TurnstileToken != null) formData.append('TurnstileToken', data.TurnstileToken);
    if (data.Nmls != null) formData.append('Nmls', data.Nmls);
    if (data.LicStates != null) formData.append('LicStates', data.LicStates);

    // Do NOT set Content-Type manually — let the browser set multipart boundary automatically
    return this.http.post<CareerApplicationResponse>(this.apiUrl, formData);
  }

  getApplications(pageNumber: number = 1, pageSize: number = 10): Observable<CareerApplicationsPage> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    return this.http.get<CareerApplicationsPage>(this.apiUrl, { params });
  }

  getApplicationById(id: number): Observable<CareerApplicationResponse> {
    return this.http.get<CareerApplicationResponse>(`${this.apiUrl}/${id}`);
  }
}
